import React, { useState } from 'react';
import { logContact } from '../services/communicationLog';

// The other side's agent on a deal (seller's agent on resale, builder rep on new construction).
export const otherAgentOf = (tx) => {
  if (tx?.propertyStatus === 'new-construction') {
    return { firstName: tx.builderRepFirstName, lastName: tx.builderRepLastName, email: tx.builderRepEmail, phone: tx.builderRepPhone };
  }
  const parts = (tx?.sellerAgent || '').trim().split(/\s+/);
  return { firstName: parts[0] || '', lastName: parts.slice(1).join(' '), email: tx?.sellerAgentEmail, phone: tx?.sellerAgentPhone };
};

// Shows on "Text Other Agent: Schedule Final Walk Through". One tap to text the other side's agent.
// Text opens an editable message, and Send marks the task done.
const isOtherAgentTask = (name) => /^Text Other Agent: .*Walk Through/i.test(name) || /Punch List Items to Builder/i.test(name) || /Confirm How the Buyer Gets the Keys/i.test(name);
const isKeysTask = (name) => /Confirm How the Buyer Gets the Keys/i.test(name);
const isPunchTask = (name) => /Punch List Items to Builder/i.test(name);

const messageFor = (first, address, senderName, isNotice) => isNotice
  ? `Hi ${first || 'there'}, we're planning the final walk-through for ${address || 'the property'} on [enter date and time]. Please let us know if anything needs to be arranged on your side. - ${senderName || 'Kelly Olin'}, RESIDENCE | eXp Realty.`
  : `Hi ${first || 'there'}, we'd like to schedule the final walk-through for ${address || 'the property'} before closing. Would [enter date and time] work for you? - ${senderName || 'Kelly Olin'}, RESIDENCE | eXp Realty.`;


export default function OtherAgentQuickText({ task, otherAgent, dealAddress, senderName, onSent }) {
  const taskName = task.name || task.title || '';
  const [open, setOpen] = useState(false);
  const [text, setText] = useState('');

  if (!isOtherAgentTask(taskName)) return null;

  const name = `${otherAgent?.firstName || ''} ${otherAgent?.lastName || ''}`.trim();
  const digits = (otherAgent?.phone || '').replace(/[^0-9+]/g, '');

  const btn = { display: 'inline-block', padding: '8px 14px', borderRadius: 6, fontWeight: 700, fontSize: 13, textDecoration: 'none', border: '1px solid #B8962E', background: '#B8962E', color: '#FFFFFF', cursor: 'pointer' };
  const btnOff = { ...btn, background: '#FFFFFF', color: '#B8962E', borderColor: '#D5D9E0', pointerEvents: 'none', opacity: 0.5 };
  const btnCancel = { ...btn, background: '#FFFFFF', color: '#5B6270', borderColor: '#D5D9E0' };

  const toggle = () => {
    if (open) { setOpen(false); return; }
    if (isKeysTask(taskName)) {
      setText(`Hi ${otherAgent?.firstName || 'there'}, we're getting close to closing on ${dealAddress || 'the property'}. Could you let us know how the buyer will get the keys (lockbox, your office, or at closing)? Please call or text me at 239-488-5900. - ${senderName || 'Kelly Olin'}, RESIDENCE | eXp Realty`);
    } else if (isPunchTask(taskName)) {
      setText(`Hi ${otherAgent?.firstName || 'there'}, we completed the final walk-through for ${dealAddress || 'the property'} and will send over our punch list items shortly. Please let me know if you have any questions. - ${senderName || 'Kelly Olin'}, RESIDENCE | eXp Realty.`);
    } else {
      setText(messageFor(otherAgent?.firstName, dealAddress, senderName, /let them know/i.test(taskName)));
    }
    setOpen(true);
  };

  return (
    <div style={{ margin: '6px 0' }}>
      <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 13, color: '#1A1A1A', fontWeight: 600 }}>Text listing agent (other side): {name || 'No agent saved'}</span>
        <button type="button" onClick={toggle} disabled={!digits} style={digits ? btn : btnOff}>Text</button>
        {digits && <span style={{ fontSize: 13, color: '#5B6270' }}>{otherAgent.phone}</span>}
        {!digits && <span style={{ fontSize: 12, color: '#5B6270' }}>No phone saved for the other side's agent</span>}
      </div>
      {open && digits && (
        <div style={{ marginTop: 8, padding: 10, border: '1px solid #D5D9E0', borderRadius: 8, background: '#FFFFFF' }}>
          <div style={{ fontSize: 13, color: '#1A1A1A', marginBottom: 8 }}>
            <strong>To:</strong> {name || 'Other side agent'} · <span style={{ color: '#5B6270' }}>{otherAgent.phone}</span>
          </div>
          <textarea value={text} onChange={(e) => setText(e.target.value)} rows={4} style={{ width: '100%', boxSizing: 'border-box', padding: 8, borderRadius: 6, border: '1px solid #D5D9E0', fontSize: 14, fontFamily: 'inherit', color: '#1A1A1A' }} />
          <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
            <a href={`sms:${digits}?body=${encodeURIComponent(text)}`} style={btn} onClick={() => { logContact(task.transactionId, { kind: 'text', toName: name, toPhone: otherAgent?.phone, role: 'Other side agent', body: text, taskName }); onSent && onSent(); }}>Send</a>
            <button type="button" onClick={() => setOpen(false)} style={btnCancel}>Cancel</button>
          </div>
        </div>
      )}
    </div>
  );
}
